import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import StatsGroupApi from './StatsGroupApi';
import StatsGroupActions from './Components/StatsGroupActions';

let settings;

export default settings = {
    key: 'users/stats/groups',
    zone: 'users',
    path: '/users/stats/groups',
    title: "Stats Group",
    endpoint: StatsGroupApi.endpoint,
    modelName: 'StatsGroup',
    idKey: 'id',
    primaryKey: 'groupName',
    indexCaps: ["viewStatsGroup"],
    viewCaps: ["viewStatsGroup"],
    createCaps: ["createStatsGroup"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [
            {
                label: "Add New",
                path: settings.path + '/create',
                caps: settings.createCaps
            }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: StatsGroupApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: ['sport'], order: ['created.date DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['groupName'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "Group name",
                key: "groupName",
                type: "text",
            },
            {
                label: "Sport",
                key: "sportId",
                type: "relationship",
                model: "Sport",
            },
        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "Group Name",
                key: "this",
                format: "ModelLink",
            },
            {
                label: "Sport",
                key: "sport",
                format: "ModelLink"
            },
            {
                label: "Created Date",
                key: "created",
                format: "OnAndBy",
                sort: "created.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                render: (value, data) => {

                    return <StatsGroupActions data={data} />;

                }
            }
        ];

        return columns;

    },
    singleFetch: StatsGroupApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ['sport'] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            {
                label: "Edit",
                path: path + "/edit"
            },
        ]

    },
};